import React, { useEffect } from 'react';
import { useState } from 'react';
import Cart from '../Cart/Cart';
import Product from '../Product/Product';
import './Food.css';

const Food = () => {
    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);
    useEffect(() => {
        fetch('./tools.JSON')
    .then(res => res.json())
    .then(data => setProducts(data))

    }, [])

    const handleAddToCart = (product) =>{
        const newCart = [...cart, product];
        setCart(newCart);
    }
    return (
        
        <div className="food-container">
              
            <div className="product-container">
              
                {
                    products.map(product => <Product
                        key = {product.name}
                        product ={product}
                        handleAddToCart = {handleAddToCart}
                        ></Product>)
                }

            </div>
            <div className="cart-container">
                <Cart cart={cart}></Cart>
            </div>
            
           
        </div>
    );
};

export default Food;